module.exports = __webpack_public_path__ + "img/1749030619_B2Hk_en.706f95eb.png";